import { computed, inject, Injectable } from '@angular/core';
import { BaseWorkflowStateService } from '../../base-workflow-state.service';
import { VideoAdditionalChannelOffersData } from '../../../../../../../models/order/workflow/video/video-additional-offer.model';
import { VideoProductResponseService } from '../../../order-api-response/video-pd-response.service';
import { VideoFlowStateService } from '../video-flow-state.service';



@Injectable({ providedIn: 'root' })
export class DTVVideoCommericalSatelliteOffersStateService extends BaseWorkflowStateService<VideoAdditionalChannelOffersData> {
    private videoPdResponseService = inject(VideoProductResponseService);
    override stateKey: string = 'dtvVideoCommericalSatelliteEquipmentOffers';
    private flowStateService = inject(VideoFlowStateService);

    customizations = computed(() => this.videoPdResponseService.getCustomizations().filter(cust =>
        cust.customization.SubGroupName === 'ATVEquipment' ||
        cust.customization.SubGroupName === 'EquipmentHDReceiverChoices' ||
        cust.customization.SubGroupName === 'EquipmentHDReceiverQuantity' ||
        cust.customization.SubGroupName === 'EquipmentHDDVRReceiverQuantity' ||
        cust.customization.SubGroupName === 'EquipmentInternetOptionChoices'
    ) || []);
    

    protected override saveLocalDraft(): void {
        this.flowStateService.updateData({ [this.stateKey]: this.state() });
    }

    getErrorChoice(){
       return this.videoPdResponseService.getCustomizations().find(x=> x.customization.CustomizationCode === "DTV-VIDEO-ERROR")?.customization?.Choices?.Choice[0];
    }

    resetData() {
        this.state.set(null);
        this.saveLocalDraft();
    }
}
